<template>
    <div class="staoPage">
        <addButton></addButton>
        <router-view></router-view>
        <div class="staoStuffHolder">
            <div class="staoTop">
                <!-- <select class="staoSortSelect" v-model="staoSort">
                    <option value="id">id</option>
                    <option value="unum">unum</option>
                    <option value="fname">fname</option>
                    <option value="lname">lname</option>
                    <option value="stao">stao</option>
                    <option value="authlev">authlev</option>
                </select> -->
                <!-- <select class="staoSortSelect" v-model="userLevFilter">
                    <option value="all">all</option>
                    <option value="%6%">lagercheff</option>
                    <option value="%0%">admin</option>
                    <option value="%T%">test</option>
                    <option value="%7%">lagerbuchen</option>
                    <option value="%3%">delete</option>
                </select>
                <select class="staoSortSelect" v-model="userStao">
                    <option value='all'>all</option>
                    <option v-for="item in staos" :value="item.id">{{item.name}}</option>
                </select> -->
                <input class="staoSelectInput" type="text" v-model="filter"/>

            </div>
            <div class="staoListHolder">
                <div v-for="item in staos"
                     :key="item.id"
                     class="staoListElement"
                     v-show="!item.hidden"
                     @click="staoInfo(item.id)"
                >
                    <div class="staoTitle">
                        <p>{{item.name}}</p>
                        <p>{{item.id}}</p>
                    </div>
                    <div class="staoTitle">
                        <p v-if="item.diag">diagnose</p>
                        <p v-if="!item.diag">-</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import addButton from './addButton';

export default {
    components: {
        addButton
    },
    data () {
        return {
            staoSort: 'id',
            filter: ''
        }
    },
    computed: {
        staos () {
            return this.$store.getters['user/staos'];
        }
    },
    methods: {
        staoInfo (id) {
            this.$store.dispatch('user/getStaoInfo', id);
        }
    },
    watch: {
        // staoSort: function(){
        //     this.$store.dispatch('user/userList',{staoSort:this.staoSort,
        //                                             levFilter:this.userLevFilter,
        //                                             stao:this.userStao});
        // },
        // userLevFilter: function(){
        //     this.$store.dispatch('user/userList',{staoSort:this.staoSort,
        //                                             levFilter:this.userLevFilter,
        //                                             stao:this.userStao});
        // },
        // userStao: function(){
        //     this.$store.dispatch('user/userList',{staoSort:this.staoSort,
        //                                             levFilter:this.userLevFilter,
        //                                             stao:this.userStao});
        // }
        staoSort: function () {
            this.$store.dispatch('user/userList', { staoSort: this.staoSort });
        },
        filter: function () {
            let userString = '';

            if (this.filter.length > 0) {
                for (let i = 0; i < this.staos.length; i++) {
                    userString = this.staos[i].name.toUpperCase();

                    // console.log(userString.includes(this.filter.toUpperCase()));

                    if (userString.includes(this.filter.toUpperCase())) {
                        this.staos[i].hidden = false;
                    } else {
                        this.staos[i].hidden = true;
                    }
                }
            } else {
                for (let i = 0; i < this.staos.length; i++) {
                    this.staos[i].hidden = false;
                }
            }
        }
    },
    created () {
        this.$store.dispatch('user/getStaos', { staoSort: this.staoSort });
    }
}
</script>

<style scoped sass>

    .staoPage {
        position: absolute;
        width: 100%;
        height: 100vh;
        /*overflow-y: scroll;*/
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .staoStuffHolder {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
    }

    .staoTop {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 200px;
    }

    .staoSortSelect {
        height: 50px;
        font-size: 30px;
    }

    .staoSelectInput {
        font-size: 25px;
        width: 80%;
    }

    .staoListHolder {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        overflow-y: scroll;
    }

    .staoListElement {
        font-size: 25px;
        padding: 5px;
        cursor: pointer;
        border-bottom: 2px solid black;
    }

    .staoListElement:hover {
        background-color: grey;
    }

    .staoTitle {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

    }

    @media screen and (min-width: 500px) {

        .staoStuffHolder {
            width: 500px;
            box-shadow: 0px 0px 60px grey;
        }

    }

    @media screen and (min-width: 1300px) {

        .staoStuffHolder {
            width: 500px;
            box-shadow: 0px 0px 60px grey;
            height: 90vh;
        }

        .staoListElement {
            font-size: 30px;
        }

        .staoTop {
            height: 80px;
            flex-direction: row;

        }
    }

</style>
